<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">{{ $t('labels.creditCard') }}</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y=""><template v-slot:activator="{ on }">
          <v-btn color="pink" small="small" v-on="on" dark="dark" icon="icon" v-if="!location.isCanceled">
            <v-icon small="small">add</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="ask">
            <v-list-tile-title>Ask Customer</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="add">
            <v-list-tile-title>Add Card</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-card-text v-if="location.stripeID">
      <v-progress-linear v-if="isLoading" size="50" width="7" indeterminate="indeterminate"
        color="pink"></v-progress-linear>
      <v-layout column="column" v-if="!isLoading"><template v-for="(card, index) in cards.sources.data">
          <v-layout justify-center="justify-center" column="column" fill-height="fill-height">
            <v-layout class="pa-2" row="row" v-if="card.id === cards.default_source">
              <v-btn icon="icon" ripple="ripple" @click="deleteCard(card)">
                <v-icon color="blue-grey lighten-3">delete</v-icon>
              </v-btn>
              <v-layout column="column">
                <v-flex class="pb-0">
                  <v-layout>
                    <v-flex class="font-weight-medium" v-if="card.object === 'card'">{{ card.brand }} - {{ card.last4
                    }}<span class="capitalize">- {{ card.funding }}</span></v-flex>
                    <v-flex class="font-weight-medium" v-else="v-else">{{ card.bank_name }} - {{ card.last4 }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex class="pt-0">
                  <v-layout>
                    <v-flex><span class="caption list-line" v-if="card.object === 'card'">{{ card.exp_month }} / {{
                      card.exp_year }}</span><span class="caption list-line" v-else="v-else">{{ card.account_holder_name
  }}</span></v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-chip small="small" color="#D0E9FF" v-if="card.object === 'card'">Card</v-chip>
              <v-chip small="small" color="#ffe8f3" v-else="v-else">ACH</v-chip>
            </v-layout>
            <v-layout class="pa-2" row="row" v-else="v-else">
              <v-btn icon="icon" ripple="ripple" @click="deleteCard(card)">
                <v-icon color="blue-grey lighten-3">delete</v-icon>
              </v-btn>
              <v-layout column="column">
                <v-flex class="pb-0">
                  <v-layout>
                    <v-flex class="font-weight-medium"><a @click="switchCard(card)" v-if="card.object === 'card'">{{
                      card.brand }} - {{ card.last4 }}<span class="capitalize">- {{ card.funding }}</span></a><a
                        @click="switchCard(card)" v-else="v-else">{{ card.bank_name }} - {{ card.last4 }}</a></v-flex>
                  </v-layout>
                </v-flex>
                <v-flex class="pt-0">
                  <v-layout>
                    <v-flex><span class="caption list-line" v-if="card.object === 'card'">{{ card.exp_month }} / {{
                      card.exp_year }}</span><span class="caption list-line" v-else="v-else">{{ card.account_holder_name
  }}</span></v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-chip small="small" color="#D0E9FF" v-if="card.object === 'card'">Card</v-chip>
              <v-chip small="small" color="#ffe8f3" v-else="v-else">ACH</v-chip>
            </v-layout>
            <v-divider v-if="index + 1 &lt; cards.sources.data.length" :key="index"></v-divider>
          </v-layout>
        </template></v-layout>
    </v-card-text>
    <CreditCard :cardDialog="cardDialog" @getCard="getCard" @close="cardDialog = false"></CreditCard>
  </v-card>
</template>

<script>
import locationService from '../service.js'
import CreditCard from '../../Invoice/components/CreditCard'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      cards: [],
      cardDialog: false,
      isLoading: true,
    }
  },
  components: {
    CreditCard
  },
  computed: {
    ...mapGetters('location', ['location'])
  },
  methods: {
    async ask() {
      const { value: email } = await this.$swal.fire({
        title: 'Ask for payment',
        input: 'email',
        inputValue: this.location.invoiceEmail,
        showCancelButton: true,
        inputPlaceholder: 'Enter New Email Address'
      })

      if (email) {
        locationService.askForPayment(this.location.storeID, { email: email })
          .then(response => {
            this.$swal.fire('Payment Information', response.data, 'success')
            // console.log('email answer back ', response)
          })
      }
    },
    add() {
      this.cardDialog = true
    },
    switchCard(card) {
      this.$swal({
        title: 'Are you sure?',
        text: `You want to make card ending with ${card.last4} default card?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          var data = {
            stripeID: this.location.stripeID,
            id: card.id,
            storeID: this.location.storeID,
          };
          return locationService.switchCard(data)
            .then((response) => {
              if (response.data) {
                this.$swal('Deleted!', 'Card has been deleted.', 'success')
              }
              this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              }).fire({
                type: 'success',
                title: 'Card switch successfully'
              })
              this.$Progress.finish()
              this.getCard()
            }).catch((error) => {
              this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              }).fire({
                type: 'error',
                title: err.data.message
              })
              this.$Progress.fail()
            })
        }
      })
    },
    getCard() {
      if (this.location.stripeID) {
        locationService.getCardByStore(this.location.storeID)
          .then(response => {
            console.log('credit card response', response)
            this.cards = response.data
            this.isLoading = false
          })
          .catch((error) => { throw error })
      }
    },
    deleteCard(card) {
      this.$swal({
        title: 'Are you sure?',
        text: `You want to remove card ending with ${card.last4}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          var data = {
            stripeID: this.location.stripeID,
            id: card.id,
            storeID: this.location.storeID,
          };
          return locationService.deleteCard(data).then((response) => {
            console.log('response', response)
            if (response.data) {
              this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              }).fire({
                type: 'success',
                title: 'Card has been deleted'
              })
              // this.$swal('Deleted!', 'Card has been deleted.', 'success')
            }
            this.$Progress.finish()
            this.getCard()
          }).catch((err) => {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              type: 'error',
              title: err.data.message
            })
            this.$Progress.fail()
          })
        }
      })
    },
  },
  watch: {
    location() {
      this.getCard()
    }
  },
  mounted() {
    this.getCard()
  }
}
</script>

<style scoped></style>
